import { render, staticRenderFns } from "./pie-graph.vue?vue&type=template&id=6f82db06&scoped=true&"
import script from "./pie-graph.vue?vue&type=script&lang=ts&"
export * from "./pie-graph.vue?vue&type=script&lang=ts&"
import style0 from "./pie-graph.vue?vue&type=style&index=0&id=6f82db06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f82db06",
  null
  
)

export default component.exports